import { ref, reactive, computed } from "@vue/composition-api";
import {
  successNotification,
  errorNotification,
} from "@/utils/toast-notifications";

export default function useQuizForm(props, ctx) {
  const questionId = computed(() => ctx.root.$route.params.id);
  const isEditMode = computed(() => !!questionId.value);

  const formLoading = ref(false);
  const submitLoading = ref(false);

  // Get current user country from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userCountry = userData?.country || "JO";

  const questionForm = reactive({
    text: "",
    text_ar: "",
    country: userCountry,
    answers: [
      { text: "", text_ar: "", is_correct: false },
      { text: "", text_ar: "", is_correct: false },
    ],
  });

  const addAnswer = () => {
    questionForm.answers.push({
      text: "",
      text_ar: "",
      is_correct: false,
    });
  };

  const removeAnswer = (index) => {
    if (questionForm.answers.length > 2) {
      questionForm.answers.splice(index, 1);
    }
  };

  const validateForm = () => {
    if (!questionForm.text.trim()) {
      errorNotification("Question text is required");
      return false;
    }

    if (questionForm.answers.length < 2) {
      errorNotification("At least 2 answers are required");
      return false;
    }

    const hasCorrectAnswer = questionForm.answers.some(
      (answer) => answer.is_correct
    );
    if (!hasCorrectAnswer) {
      errorNotification("At least one answer must be marked as correct");
      return false;
    }

    const hasEmptyAnswers = questionForm.answers.some(
      (answer) => !answer.text.trim() || !answer.text_ar.trim()
    );
    if (hasEmptyAnswers) {
      errorNotification("All answers must have text");
      return false;
    }

    return true;
  };

  const submitForm = async () => {
    if (!validateForm()) return;

    try {
      submitLoading.value = true;

      const payload = {
        text: questionForm.text,
        text_ar: questionForm.text_ar,
        country: questionForm.country,
        answers: questionForm.answers.map((answer) => ({
          text: answer.text,
          text_ar: answer.text_ar,
          is_correct: answer.is_correct,
        })),
      };

      if (isEditMode.value) {
        await ctx.root.$store.dispatch("learningCenterQuiz/updateQuestion", {
          questionId: questionId.value,
          questionData: payload,
        });
        successNotification("Question updated successfully");
      } else {
        await ctx.root.$store.dispatch(
          "learningCenterQuiz/createQuestion",
          payload
        );
        successNotification("Question created successfully");
      }

      ctx.root.$router.push("/learning-center-quiz");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "An error occurred";
      errorNotification(errorMsg);
    } finally {
      submitLoading.value = false;
    }
  };

  const fetchQuestion = async () => {
    if (!isEditMode.value) return;

    try {
      formLoading.value = true;
      const response = await ctx.root.$store.dispatch(
        "learningCenterQuiz/getQuestion",
        questionId.value
      );
      const question = response.data.data.data;

      questionForm.text = question.text;
      questionForm.text_ar = question.text_ar || "";
      questionForm.country = userCountry; // Always use current user's country
      questionForm.answers = question.answers.map((answer) => ({
        text: answer.text,
        text_ar: answer.text_ar || "",
        is_correct: answer.is_correct,
      }));
    } catch (error) {
      console.log(error);
      errorNotification("Failed to load question");
      //   ctx.root.$router.push('/learning-center-quiz')
    } finally {
      formLoading.value = false;
    }
  };

  if (isEditMode.value) {
    fetchQuestion();
  }

  return {
    questionForm,
    formLoading,
    submitLoading,
    isEditMode,
    addAnswer,
    removeAnswer,
    submitForm,
  };
}
